import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import InputText from "../Components/InputText";
import PageNavigation from "../Components/PageNavigation";
import InputOptions from "../Components/InputOptions";
import Steps from "./steps";

export type ServicesRequiredFields = {
    services_required: string;
    services_required_other: string;
}

export class ServicesRequired extends React.Component<PageProps<ServicesRequiredFields> & Partial<StepWizardChildProps>, PageState> {
    constructor(props: PageProps<ServicesRequiredFields>) {
        super(props);

        this.state = {
            validation_triggered: false
        };
    }

    triggerValidation()
    {
        const page_fields = ["services_required"];

        if (this.props.form_values.services_required && this.props.form_values.services_required.includes("Other")) {
            page_fields.push("services_required_other");
        }

        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    goBack() {
        if (this.props.previousStep) {
            this.props.previousStep();
        }
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        if (this.props.nextStep) {
            this.props.nextStep();
        }
    }

    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>
            <InputOptions
                label="Services Required?"
                name="services_required"
                additional_classes="landing-services-required"
                options={[
                    {
                        label: "Cleaning",
                        value: "Cleaning",
                        details: <img src="/site/img/booking-v2/service-cleaning.svg" alt="Cleaning"/>
                    },
                    {
                        label: "Ironing",
                        value: "Ironing",
                        details: <img src="/site/img/booking-v2/service-ironing.svg" alt="Ironing"/>
                    },
                    {
                        label: "Bed Changing",
                        value: "Bed Changing",
                        details: <img src="/site/img/booking-v2/service-bed.svg" alt="Ironing"/>
                    },
                    {
                        label: "Vacuuming",
                        value: "Vacuuming",
                        details: <img src="/site/img/booking-v2/service-vacuuming.svg" alt="Vacuuming"/>
                    },
                    {
                        label: "Inside Windows",
                        value: "Inside Windows",
                        details: <img src="/site/img/booking-v2/service-windows.svg" alt="Inside Windows"/>
                    },
                    {
                        label: "Other",
                        value: "Other",
                        details: <img src="/site/img/booking-v2/service-other.svg" alt="Other"/>
                    },
                ]}
                is_exclusive={false}
                value={this.props.form_values.services_required}
                required={this.props.required.services_required}
                validation_message="Please select at least one service"
                validation_triggered={this.state.validation_triggered}
                validation_get_scrolled={getScrolled}
                validation_set_scrolled={setScrolled}
                update_value={this.props.update_value}
            />

            {
                this.props.form_values.services_required && this.props.form_values.services_required.includes("Other") ?
                    <InputText
                        label="Please provide details about the clean you require"
                        type="textarea"
                        rows={4}
                        name="services_required_other"
                        value={this.props.form_values.services_required_other}
                        required={this.props.required.services_required_other}
                        validation_message="Please provide details about the clean you require"
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    /> : null
            }

            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={true} allowNext={true} useSubmitForNext={false} onNext={() => this.submit()} onPrevious={() => this.goBack()}/>
                </div>
            </div>
        </div>;
    }
}